var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',_vm._b({staticClass:"video-js",attrs:{"data-application-id":"","muted":"","playsinline":"","controlsList":"nodownload"},domProps:{"muted":true}},'video',_vm.bcAttrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }